/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banners_Inbox_Mark_ReadInputs */

const de_banners_inbox_mark_read = /** @type {(inputs: Banners_Inbox_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelesen`)
};

/** @type {(inputs: Banners_Inbox_Mark_ReadInputs) => LocalizedString} */
const en_banners_inbox_mark_read = de_banners_inbox_mark_read;

/**

* @param {Banners_Inbox_Mark_ReadInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const banners_inbox_mark_read = /** @type {((inputs?: Banners_Inbox_Mark_ReadInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banners_Inbox_Mark_ReadInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_banners_inbox_mark_read(inputs)
	return en_banners_inbox_mark_read(inputs)
});